export interface MusicPlayerOptions {
  readonly element?: HTMLAudioElement;
  readonly volume?: number;
}

export class MusicPlayer {
  private readonly element: HTMLAudioElement;
  private currentUrl: string | null = null;
  private wantPlay = false;

  constructor(options: MusicPlayerOptions = {}) {
    this.element = options.element ?? new Audio();
    this.element.preload = "none";
    this.element.loop = true;
    this.element.volume = options.volume ?? 0.6;
  }

  load(url: string): void {
    if (this.currentUrl === url) return;
    this.currentUrl = url;
    this.element.src = url;
  }

  setMuted(muted: boolean): void {
    this.element.muted = muted;
  }

  async play(): Promise<boolean> {
    if (this.currentUrl === null) return false;
    this.wantPlay = true;
    try {
      await this.element.play();
      return true;
    } catch {
      return false;
    }
  }

  pause(): void {
    this.wantPlay = false;
    this.element.pause();
  }

  dispose(): void {
    this.pause();
    if (this.currentUrl !== null) {
      this.element.removeAttribute("src");
      this.element.load();
      this.currentUrl = null;
    }
  }

  get hasSource(): boolean {
    return this.currentUrl !== null;
  }

  get isPlaying(): boolean {
    return this.wantPlay && !this.element.paused;
  }
}
